import { render, staticRenderFns } from "./PlatformExistStatus.vue?vue&type=template&id=4bbf5abc&"
import script from "./PlatformExistStatus.vue?vue&type=script&lang=js&"
export * from "./PlatformExistStatus.vue?vue&type=script&lang=js&"
import style0 from "./PlatformExistStatus.vue?vue&type=style&index=0&id=4bbf5abc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports